import axios from 'axios';
import Config from "@/mixins/Config";
import AuthService from "@/mixins/AuthService";

export default {
  name: 'FileUploadService',
  mixins: [
    Config,
    AuthService
  ],
  methods: {
    async uploadFile(docType, fileInfo, onUploadProgress) {
      let url = this.config.apiBaseUrl_CRM + '/crm/account/documents';
      let auth = await this.isAuthenticated();

      let config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': auth.signInUserSession.idToken.jwtToken,
          'file-name': fileInfo.file.name,
          'file-type': fileInfo.file.type,
          'file-size': fileInfo.file.size,
          'file-doc-ref': fileInfo.ref,
          'file-title': fileInfo.title || fileInfo.file.name,
          'file-doc-type': docType,
        },
        onUploadProgress
      }

      return axios.post(url, fileInfo.file, config);
    },
    getDataWithAuth(url) {
      return new Promise((resolve, reject) => {
        this.isAuthenticated().then(auth => {
          if (auth) {
            axios.get(url, {
              headers: {
                'Authorization': auth.signInUserSession.idToken.jwtToken
              }
            }).then(res => resolve(res),
              err => reject(err));
          } else {
            reject('Not Logged In');
          }
        }, err => reject(err));

      })
    },
    getFiles() {
      return axios.get("/files");
    }
  }
}
// export default new FileUploadService();
